import DatePicker from 'antd/lib/date-picker';
import moment from 'moment';
import React from 'react';

export const AffiliationDatePicker = ({
  input,
  minDate,
  maxDate,
  placeholder,
  disabled,
}: {
  input: any;
  minDate: Date;
  maxDate: Date;
  placeholder: string;
  disabled: boolean;
}): JSX.Element => {
  const handleDisableDate = (day: moment.Moment): boolean => {
    if (minDate) {
      return moment(day).isBefore(minDate || moment.unix(1));
    }
    if (maxDate) {
      return moment(day).isAfter(maxDate || moment.unix(1));
    }
    return false;
  };

  return (
    <div
      style={{
        display: 'flex',
        verticalAlign: 'top',
      }}
    >
      <DatePicker
        value={(input?.value && moment(input?.value)) || null}
        format="YYYY-MM-DD"
        disabled={disabled}
        placeholder={placeholder}
        size="large"
        allowClear
        disabledDate={handleDisableDate}
        onChange={(date): void => {
          if (date) {
            input.onChange(date);
          } else {
            input.onChange(null);
          }
        }}
        style={{ borderRadius: '16px', width: '100%' }}
      />
    </div>
  );
};
export default AffiliationDatePicker;
